import { useTranslation } from 'react-i18next';
import { Form, Label } from '@anytag/shared-atoms';
import { FOLLOWER_GROWTH_PERIOD_OPTIONS, FOLLOWER_GROWTH_RATE_RATIO_OPTIONS } from '@anytag/shared-constants';
import { useTranslateOptions } from '@anytag/shared-hooks';
import { SelectorField } from '@anytag/shared-molecules';
import { InfluencersFilterFormKeys } from '../schemaTypes';

interface FollowerGrowthRateProps {
  title?: string;
  className?: string;
}

export const FollowerGrowthRate = ({ title, className }: FollowerGrowthRateProps) => {
  const { t } = useTranslation();
  const followerGrowthPeriodOptions = useTranslateOptions(FOLLOWER_GROWTH_PERIOD_OPTIONS);

  return (
    <Form.Field className={className}>
      <Label title={title ?? t('Follower Growth Rate')} className="mb-2.75 p-0" />
      <Form.Fields itemsPerRow={2}>
        <SelectorField<InfluencersFilterFormKeys>
          title={t('Selector.Period')}
          name="followerGrowthPeriod"
          options={followerGrowthPeriodOptions}
        />

        <SelectorField<InfluencersFilterFormKeys>
          title={t('Selector.Ratio')}
          name="followerGrowthPercentage"
          options={FOLLOWER_GROWTH_RATE_RATIO_OPTIONS}
        />
      </Form.Fields>
    </Form.Field>
  );
};
